import { EventKind } from "@nova/schemas"
import { VariablesSupportedBy } from "./variables"

export const notifiableEventKinds = [
    EventKind.LayerProcessed,
    EventKind.LayerProcessingFailed,
    EventKind.StreamStarted,
    EventKind.LocationSharingStarted,
    EventKind.LocationSharingEnded,
    EventKind.StreamShared,
    EventKind.MissionGroupStreamShared,
    EventKind.MissionGroupDashboardShared,
    EventKind.AccessRequested,
    EventKind.AccessGranted,
    EventKind.CommentCreated,
] as const satisfies EventKind[]

export type NotifiableEventKind = (typeof notifiableEventKinds)[number]

export const notificationVariablesByEventKind = {
    [EventKind.LayerProcessed]: ["projectName", "layerTypeLabel"],
    [EventKind.LayerProcessingFailed]: ["projectName", "layerTypeLabel"],
    [EventKind.StreamStarted]: ["actorName", "projectName"],
    [EventKind.LocationSharingStarted]: ["actorName", "projectName"],
    [EventKind.LocationSharingEnded]: ["actorName", "projectName"],
    [EventKind.StreamShared]: ["actorName", "projectName"],
    [EventKind.MissionGroupStreamShared]: ["actorName"],
    [EventKind.MissionGroupDashboardShared]: ["actorName"],
    [EventKind.AccessRequested]: ["actorName", "accessResourceName"],
    [EventKind.AccessGranted]: ["accessResourceName", "entityType", "permissionLabel"],
    [EventKind.CommentCreated]: ["actorName", "projectName", "commentSnippet"],
} as const satisfies {
    [K in NotifiableEventKind]: readonly VariablesSupportedBy<K>[]
}

export type VariablesFor<K extends NotifiableEventKind> =
    (typeof notificationVariablesByEventKind)[K][number]

export const isNotifiableEventKind = (kind: EventKind): kind is NotifiableEventKind =>
    kind in notificationVariablesByEventKind
